import React, { useState } from "react";
import { Box, Divider, IconButton, Typography, Drawer } from "@mui/material";
import { NavLink } from "react-router-dom";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import PersonIcon1 from "../../assets/PersonIcon.svg";
import { ReactComponent as PermIdentityOutlinedIcon } from "../../assets/homePage/drop-profile.svg";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ledgerIcon from "../../assets/customerNavbarIcons/ledger.svg";
import useIsMobile from "../../common/mobileVersion/useIsMobile";

const navLinkStyle = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  color: "black",
  textDecoration: "none",
};

const iconStyle = {
  width: "20px",
  height: "18px",
};

interface MobileDrawerProps {
  drawerOpen: boolean;
  toggleDrawer: (open: boolean) => void;
}

const navItems = [
  { to: "home", icon: <HomeOutlinedIcon style={iconStyle} />, label: "Home" },
  {
    to: "products",
    icon: <InboxOutlinedIcon style={iconStyle} />,
    label: "Products",
  },
  {
    to: "help-support",
    icon: <InfoOutlinedIcon style={iconStyle} />,
    label: "Support",
  },
  {
    to: "customer-profile",
    icon: <PermIdentityOutlinedIcon style={iconStyle} />,
    label: "Profile",
  },
  {
    to: "ledgers",
    icon: (
      <img
        src={ledgerIcon}
        alt="Ledger Icon"
        style={{ width: "18px", height: "18px" }}
      />
    ),
    label: "Ledger",
  },
  {
    to: "my-orders",
    icon: <ShoppingCartOutlinedIcon style={iconStyle} />,
    label: "My Orders",
  },
  { to: "/", icon: <LogoutOutlinedIcon style={iconStyle} />, label: "Log Out" },
];

const MobileDrawer = ({ drawerOpen, toggleDrawer }: MobileDrawerProps) => {
  const [userName] = useState<string>(localStorage.getItem("Name") || "");
  const isMobile = useIsMobile();

  return (
    <Drawer
      anchor="left"
      open={drawerOpen}
      onClose={() => toggleDrawer(false)}
      sx={{
        "& .MuiDrawer-paper": {
          width: "180px",
        },
      }}
    >
      <Box
        sx={{
          height: "45px",
          display: "flex",
          alignItems: "center",
          gap: 7,
          backgroundColor: "rgba(51, 51, 51, 1)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1px",
          }}
        >
          <IconButton>
            <img
              src={PersonIcon1}
              alt="profile-icon"
              style={{ width: "12px", height: "12px" }}
            />
          </IconButton>
          <Typography sx={{ color: "white", fontSize: "10px" }}>
            {userName}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          padding: "16px 12px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: 2,
          color: "black",
        }}
      >
        {navItems.slice(0, 3).map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            style={navLinkStyle}
            onClick={() => toggleDrawer(false)}
          >
            {item.icon}
            <Typography variant="body1" sx={{ fontSize: "10px" }}>
              {item.label}
            </Typography>
          </NavLink>
        ))}

        <Divider
          sx={{
            width: "100%",
            border: "1px solid rgba(0, 0, 0, 0.5)",
          }}
        />

        {navItems.slice(3).map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            style={navLinkStyle}
            onClick={() => toggleDrawer(false)}
          >
            {item.icon}
            <Typography variant="body1" sx={{ fontSize: "10px" }}>
              {item.label}
            </Typography>
          </NavLink>
        ))}
      </Box>
    </Drawer>
  );
};

export default MobileDrawer;
